module.exports = __webpack_public_path__ + "static/media/hb.535b767d.svg";